import { getModelTypeColor } from "helpers/utility/utilities";
import { ModelTypes } from "types";

import { SemanticObjectSearchIcon } from "assets/icons/SemanticObjectSearchIcon";
import { SemanticImageSearchIcon } from "assets/icons/SemanticImageSearchIcon";
import UserTagIcon from "assets/icons/UserTagIcon";
import ObjectIcon from "assets/icons/ObjectIcon";
import TagIcon from "assets/icons/tagIcon";

import styles from "./style.module.scss";

const ModelBadge = ({ modelType }: { modelType: ModelTypes }) => {
  const { color, backgroundColor } = getModelTypeColor(modelType);
  const renderModelTypeIcon = (ModelType: ModelTypes): JSX.Element => {
    switch (ModelType) {
      case ModelTypes.IMAGE_TAGGING:
        return <TagIcon />;
      case ModelTypes.OBJECT_TAGGING:
        return <TagIcon />;
      case ModelTypes.OBJECT_DETECTION:
        return <ObjectIcon />;
      case ModelTypes.MULTIMODEL_IMAGE_ENCODING:
        return <SemanticImageSearchIcon />;
      case ModelTypes.MULTIMODEL_OBJECT_ENCODING:
        return <SemanticObjectSearchIcon />;

      default:
        return <UserTagIcon />;
    }
  };

  return (
    <div className={styles.modelBadge} style={{ color, backgroundColor }}>
      {renderModelTypeIcon(modelType)}
    </div>
  );
};

export default ModelBadge;
